const AGREEMENT_SLUG_PATTERN = /^agr_[A-Za-z0-9_-]{1,508}$/;
const LEGACY_AGREEMENT_SLUG_PATTERN = /^[A-Za-z0-9@+.-]{4,128}$/;

export const isCanonicalAgreementSlug = (
  slug: string | undefined
): slug is string => Boolean(slug && AGREEMENT_SLUG_PATTERN.test(slug));

export const isLegacyAgreementSlug = (
  slug: string | undefined
): slug is string =>
  Boolean(
    slug && slug.length % 4 === 0 && LEGACY_AGREEMENT_SLUG_PATTERN.test(slug)
  );

type AgreementResolverResponse = {
  success?: boolean;
  data?: {
    agreementSlug?: string;
  };
  body?: {
    success?: boolean;
    data?: {
      agreementSlug?: string;
    };
  };
};

export const getCanonicalAgreementSlug = (
  response: AgreementResolverResponse | undefined
): string | null => {
  const payload = response?.body || response;
  const agreementSlug = payload?.data?.agreementSlug;

  return payload?.success === true && isCanonicalAgreementSlug(agreementSlug)
    ? agreementSlug
    : null;
};

type AgreementRedirectOptions = {
  currentSlug?: string;
  canonicalSlug?: string;
  origin: string;
  search?: string;
  hash?: string;
};

export const buildCanonicalAgreementRedirectUrl = ({
  currentSlug,
  canonicalSlug,
  origin,
  search = "",
  hash = "",
}: AgreementRedirectOptions): string | null => {
  if (
    !currentSlug ||
    !canonicalSlug ||
    currentSlug === canonicalSlug ||
    !isCanonicalAgreementSlug(canonicalSlug)
  ) {
    return null;
  }

  const canonicalBaseUrl = new URL("/", origin);
  const destination = new URL(
    `agreement/${encodeURIComponent(canonicalSlug)}`,
    canonicalBaseUrl
  );

  destination.search = search;
  destination.hash = hash;

  return destination.toString();
};

export const getSameOriginAgreementRoute = (
  redirectUrl: string,
  origin: string
): string | null => {
  try {
    const destination = new URL(redirectUrl);
    const expectedOrigin = new URL(origin).origin;

    if (
      destination.origin !== expectedOrigin ||
      !destination.pathname.startsWith("/agreement/")
    ) {
      return null;
    }

    return `${destination.pathname}${destination.search}${destination.hash}`;
  } catch {
    return null;
  }
};
